export const splitCodes = (value) => String(value || '').split(',').map(code => code.trim()).filter(Boolean)

/**
 * Sync a menuTop code against a set of menuChildren codes, using an
 * "originalCode" string (from the role/permission source of truth) as
 * reference. Codes present in originalCode are added to menuChildren; codes
 * absent are removed. topCode is added to menuTop when at least one
 * childCode matches, and left untouched otherwise (never removed, since
 * topCode may still be required by unrelated menu children).
 */
export const syncMenuPermission = (menuTop, menuChildren, originalCode, { topCode, childCodes }) => {
    const originalCodes = splitCodes(originalCode)
    const matchedCodes = childCodes.filter(code => originalCodes.includes(code))

    const childSet = new Set(splitCodes(menuChildren))
    childCodes.forEach(code => {
        if (originalCodes.includes(code)) {
            childSet.add(code)
        } else {
            childSet.delete(code)
        }
    })

    const topSet = new Set(splitCodes(menuTop))
    if (matchedCodes.length > 0) {
        topSet.add(topCode)
    }

    return {
        menuTop: Array.from(topSet).join(','),
        menuChildren: Array.from(childSet).join(','),
    }
}

/**
 * Apply multiple syncMenuPermission rules in sequence. Add a new rule here
 * whenever another menu needs the same "originalCode drives menuTop +
 * menuChildren" behavior as kas kecil.
 */
export const MENU_PERMISSION_SYNC_RULES = [
    { topCode: 'KSR', childCodes: ['MRC', 'AMC', 'MIE', 'MVR', 'MAV', 'MPP', 'MBH', 'MXL'] },
    { topCode: 'LEL', childCodes: ['LDO', 'LPO'] },
]

export const syncAllMenuPermissions = (menuTop, menuChildren, originalCode, rules = MENU_PERMISSION_SYNC_RULES) => {
    return rules.reduce((acc, rule) => syncMenuPermission(acc.menuTop, acc.menuChildren, originalCode, rule), {
        menuTop,
        menuChildren,
    })
}
